/** The Data tables screen (ADR-0106): small organisation tables agents read and keep. */
export default {
  en: {
    title: "Data tables",
    subtitle: "Small tables agents read and keep — what they already did, the last run, trackers and reference lists you edit.",
    new: "New table",
    none: "No data tables yet. Make one for what agents should remember, e.g. “Reminders sent”.",
    pick: "Choose a table on the side to see its rows.",
    rows_one: "{{count}} row",
    rows_other: "{{count}} rows",
    agentsMay: "Agents may change it",
    peopleOnly: "Only people change it",
    key: "Each row is found by its ‘{{column}}’",
    search: "Find rows",
    addRow: "Add a row",
    editRow: "Change the row ‘{{key}}’",
    removeRow: "Remove the row ‘{{key}}’?",
    removeRowYes: "Remove",
    removed: "Row removed.",
    saved: "Row saved.",
    import: "Import from CSV",
    importTitle: "Import rows from a CSV file",
    importHelp: "The first line names the columns (as in this table, e.g. {{columns}}). Rows with a key that already exists are changed.",
    importFile: "CSV file",
    importAdd: "Add and change rows",
    importReplace: "Replace all rows",
    imported: "{{rows}} rows read: {{added}} added, {{changed}} changed.",
    importProblems: "Some lines don't fit the table ({{count}}); nothing was imported.",
    download: "Download CSV",
    changes: "Who changed what",
    changesTitle: "Changes to ‘{{table}}’",
    changesNone: "No changes yet.",
    change: {
      added: "{{who}} added ‘{{key}}’",
      changed: "{{who}} changed ‘{{key}}’",
      removed: "{{who}} removed ‘{{key}}’",
      restored: "{{who}} put back ‘{{key}}’",
    },
    byAgent: "the agent ‘{{agent}}’",
    byPerson: "{{name}}",
    lastChange: "Last changed",
    lastByAgent: "by the agent ‘{{agent}}’",
    lastByPerson: "by {{name}}",
    actions: "Actions",
    edit: "Change",
    remove: "Remove",
    settings: "Settings",
    deleteTable: "Delete this table",
    deleteConfirm: "Delete ‘{{table}}’ and all its rows? Agents that use it will find nothing.",
    deleted: "Table deleted.",
    readOnly: "You can see this table; your role doesn't change it.",
    form: {
      titleEn: "Name (English)",
      titleAr: "Name (Arabic)",
      descriptionEn: "What it is for (English)",
      descriptionAr: "What it is for (Arabic)",
      columns: "Columns",
      columnEn: "Column name (English)",
      columnAr: "Column name (Arabic)",
      kind: "Kind",
      kinds: { text: "Text", number: "Number", date: "Date", yes_no: "Yes or no" },
      addColumn: "Add a column",
      removeColumn: "Remove column {{n}}",
      keyColumn: "The column that names each row (its key)",
      keyHelp: "Agents find a row by it, e.g. the invoice number.",
      agentsMay: "Agents may add and change rows",
      agentsMayHelp: "Off: agents only read it; people keep it up to date (e.g. a holiday list).",
      internal: "Data tables hold Internal data at most. Keep confidential records in their own system.",
      create: "Make the table",
      cancel: "Cancel",
      save: "Save",
      name: "Name in agents",
      yes: "Yes",
      no: "No",
    },
    issues: {
      title_required: "Give the table a name.",
      columns_required: "Add at least one column with a name.",
      key_required: "Choose the column that names each row.",
      name_invalid: "Use English letters in the English name: it names the table for agents.",
    },
    useIn: "Agents use it with a ‘Use a system’ step: Data tables › Look up a row, Save a row, Add to a number.",
  },
  ar: {
    title: "جداول البيانات",
    subtitle: "جداول صغيرة يقرؤها الوكلاء ويحفظونها — ما فعلوه من قبل، وآخر تشغيل، والمتابعات، والقوائم المرجعية التي تحررونها.",
    new: "جدول جديد",
    none: "لا توجد جداول بيانات بعد. أنشئ واحداً لما يجب أن يتذكره الوكلاء، مثل «التذكيرات المرسلة».",
    pick: "اختر جدولاً من الجانب لترى صفوفه.",
    rows_zero: "لا صفوف",
    rows_one: "صف واحد",
    rows_two: "صفان",
    rows_few: "{{count}} صفوف",
    rows_many: "{{count}} صفاً",
    rows_other: "{{count}} صف",
    agentsMay: "يمكن للوكلاء تغييره",
    peopleOnly: "يغيّره الأشخاص فقط",
    key: "يُعثر على كل صف بـ‹{{column}}›",
    search: "البحث في الصفوف",
    addRow: "إضافة صف",
    editRow: "تغيير الصف ‹{{key}}›",
    removeRow: "حذف الصف ‹{{key}}›؟",
    removeRowYes: "حذف",
    removed: "حُذف الصف.",
    saved: "حُفظ الصف.",
    import: "استيراد من CSV",
    importTitle: "استيراد صفوف من ملف CSV",
    importHelp: "السطر الأول يسمّي الأعمدة (كما في هذا الجدول، مثل {{columns}}). الصفوف التي مفتاحها موجود تُغيَّر.",
    importFile: "ملف CSV",
    importAdd: "إضافة الصفوف وتغييرها",
    importReplace: "استبدال كل الصفوف",
    imported: "قُرئ {{rows}} صفاً: أُضيف {{added}} وغُيّر {{changed}}.",
    importProblems: "بعض الأسطر لا تناسب الجدول ({{count}})؛ لم يُستورد شيء.",
    download: "تنزيل CSV",
    changes: "من غيّر ماذا",
    changesTitle: "التغييرات على ‹{{table}}›",
    changesNone: "لا تغييرات بعد.",
    change: {
      added: "أضاف {{who}} ‹{{key}}›",
      changed: "غيّر {{who}} ‹{{key}}›",
      removed: "حذف {{who}} ‹{{key}}›",
      restored: "أعاد {{who}} ‹{{key}}›",
    },
    byAgent: "الوكيل ‹{{agent}}›",
    byPerson: "{{name}}",
    lastChange: "آخر تغيير",
    lastByAgent: "بواسطة الوكيل ‹{{agent}}›",
    lastByPerson: "بواسطة {{name}}",
    actions: "الإجراءات",
    edit: "تغيير",
    remove: "حذف",
    settings: "الإعدادات",
    deleteTable: "حذف هذا الجدول",
    deleteConfirm: "حذف ‹{{table}}› وكل صفوفه؟ لن يجد الوكلاء الذين يستخدمونه شيئاً.",
    deleted: "حُذف الجدول.",
    readOnly: "يمكنك رؤية هذا الجدول؛ ودورك لا يغيّره.",
    form: {
      titleEn: "الاسم (بالإنجليزية)",
      titleAr: "الاسم (بالعربية)",
      descriptionEn: "الغرض منه (بالإنجليزية)",
      descriptionAr: "الغرض منه (بالعربية)",
      columns: "الأعمدة",
      columnEn: "اسم العمود (بالإنجليزية)",
      columnAr: "اسم العمود (بالعربية)",
      kind: "النوع",
      kinds: { text: "نص", number: "رقم", date: "تاريخ", yes_no: "نعم أو لا" },
      addColumn: "إضافة عمود",
      removeColumn: "حذف العمود {{n}}",
      keyColumn: "العمود الذي يسمّي كل صف (مفتاحه)",
      keyHelp: "يعثر الوكلاء على الصف به، مثل رقم الفاتورة.",
      agentsMay: "يمكن للوكلاء إضافة الصفوف وتغييرها",
      agentsMayHelp: "عند الإيقاف: يقرؤه الوكلاء فقط؛ ويحدّثه الأشخاص (مثل قائمة العطل).",
      internal: "تحفظ جداول البيانات بيانات «داخلية» على الأكثر. احفظ السجلات السرية في نظامها.",
      create: "إنشاء الجدول",
      cancel: "إلغاء",
      save: "حفظ",
      name: "الاسم لدى الوكلاء",
      yes: "نعم",
      no: "لا",
    },
    issues: {
      title_required: "أعطِ الجدول اسماً.",
      columns_required: "أضف عموداً واحداً على الأقل باسم.",
      key_required: "اختر العمود الذي يسمّي كل صف.",
      name_invalid: "استخدم أحرفاً إنجليزية في الاسم الإنجليزي: فهو يسمّي الجدول لدى الوكلاء.",
    },
    useIn: "يستخدمه الوكلاء بخطوة «استخدام نظام»: جداول البيانات › البحث عن صف، حفظ صف، الإضافة إلى رقم.",
  },
};
